<template>
  <div class="content-page">
    <div class="tab-header">
      <span style="margin-right:10px">审核状态</span>
      <el-select v-model="value" placeholder="请选择" @change="selectChange">
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
    </div>
    <div class="tab-content">
      <el-table :data="applyList" style="width: 100%" :max-height="550">
        <el-table-column
          align="left"
          prop="phoneNum"
          label="手机号"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="fullName"
          label="姓名"
        />
        <el-table-column
          align="center"
          prop="sex"
          label="性别"
        >
        <template slot-scope="scope">
            {{ scope.row.sex == 1 ? '男' : scope.row.sex == 0 ? '女' : '' }}
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="status"
          label="审核状态"
        >
        <!-- 0 审核中 1 审核通过 2 审核失败 -->
        <template slot-scope="scope">
            {{ scope.row.status == 0 ? '审核中' : scope.row.status == 1 ? '审核通过' : scope.row.status == 2 ? '审核失败' : '' }}
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="modifyTime"
          label="申请时间"
          width="380"
        />
        <el-table-column align="center" label="操作" width="300">
          <template slot-scope="scope">
            <el-button type="primary" v-show="scope.row.status == 0" size="small" @click="delActive('pass', scope.row.shopMemberApplyOrderId)"
              >通过</el-button
            >
            <el-button type="danger" v-show="scope.row.status == 0" size="small" @click="delActive('refuse', scope.row.shopMemberApplyOrderId)"
              >拒绝</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div v-show="applyList.length > 0" style="padding-left:15px;">
      <el-pagination
        @current-change="handleCurrentChange"
        :page-size="queryInfo.row"
        :current-page="queryInfo.pageNo"
        background
        layout="total, prev, pager, next"
        :total="total"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import {
  getShopMemberApplyOrderList,
  getShopMemberApplyOrderListCount,
  handleShopMemberApplyOrder
} from "../api/index";
export default {
  data() {
    return {
      queryInfo: {
        pageNo: 1,
        row: 10,
      },
      total: 0,
      applyList: [],
      value: "",
      options: [
        {
          value: '',
          label: '全部审核状态  '
        },
        {
          value: 0,
          label: '审核中'
        },
        {
          value: 1,
          label: '审核通过'
        },
        {
          value: 2,
          label: '审核失败'
        },
      ]
    };
  },
  mounted() {
    this.getShopMemberApplyOrderList();
  },
  methods: {
    getShopMemberApplyOrderList() {
      console.log(this.value, 234)
      getShopMemberApplyOrderList({
        pageNo: this.queryInfo.pageNo,
        row: this.queryInfo.row,
        status: this.value
      }).then((res) => {
        if (res.code == 1) {
          this.applyList = res.data;
          getShopMemberApplyOrderListCount({
            pageNo: this.queryInfo.pageNo,
            row: this.queryInfo.row,
            status: this.value
          })
          .then(res => {
            if (res.code == 1) {
              this.total = res.data.count
            }
          })
        } else if (res.code == -1) {
          this.applyList = [];
          this.total = 0
        } else {
        }
      });
    },
    handleCurrentChange(val) {
      this.queryInfo.pageNo = val;
      this.getShopMemberApplyOrderList();
    },
    selectChange() {
      console.log(123, this.value)
      this.getShopMemberApplyOrderList();
    },
    delActive(row, shopMemberApplyOrderId) {
      console.log(row, "delActive", shopMemberApplyOrderId);
      // return
      if (row == 'refuse') {
        this.$confirm("此操作将拒绝该申请, 是否继续", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(({ value }) => {
          handleShopMemberApplyOrder({
            status: 2,
            shopMemberApplyOrderId: shopMemberApplyOrderId
          }).then((res) => {
            if (res.code == 1) {
              this.$notify({
                title: "提示",
                message: "操作成功",
                type: "success",
                duration: 1000,
              });
              this.getShopMemberApplyOrderList();
            } else {
              this.$notify({
                title: "提示",
                message: res.msg,
                type: "error",
                duration: 3000,
              });
            }
          });
        });
      } else if (row == 'pass') {
        this.$confirm("此操作将通过该申请, 是否继续", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(({ value }) => {
          handleShopMemberApplyOrder({
            status: 1,
            shopMemberApplyOrderId: shopMemberApplyOrderId
          }).then((res) => {
            if (res.code == 1) {
              this.$notify({
                title: "提示",
                message: "操作成功",
                type: "success",
                duration: 1000,
              });
              this.getShopMemberApplyOrderList();
            } else {
              this.$notify({
                title: "提示",
                message: res.msg,
                type: "error",
                duration: 3000,
              });
            }
          });
        });
      } else { }
    },
  },
};
</script>

<style lang="less" scoped>
.content-page {
  .tab-header {
  }
  .tab-content {
    // width: calc(100vw - 280px);
    padding: 0 15px;
  }
}
</style>
